import React, { useState } from 'react';
import axios from 'axios';
import { Input, Button, Typography, Form, Layout, Select, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import '../styles/Register.css';
import logo from '../images/logo.png'; 
import { apiUrl } from './config';  // Modifica il percorso in base alla posizione del file


const { Title } = Typography;
const { Content } = Layout;
const { Option } = Select;

const Register = () => {
    const [nome, setNome] = useState('');
    const [cognome, setCognome] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [role, setRole] = useState('');
    const [trainerId, setTrainerId] = useState('');
    const [adminPassword, setAdminPassword] = useState('');  // Nuovo stato per la password amministrativa
    const [messageText, setMessageText] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async () => {
        if (!nome || !cognome || !email || !password || !role || !adminPassword || !trainerId) {
            setMessageText('Compila tutti i campi');
            return;
        }

        try {
            const normalizedEmail = email.toLowerCase();
            const privacyAccepted = true;
            const privacyAcceptedAt = new Date('2023-11-01T10:00:00Z');

            await axios.post(`${apiUrl}/api/auth/register`, {
                nome,
                cognome,
                email: normalizedEmail, 
                password,
                role,
                trainerId,
                adminPassword,
                privacyAccepted,
                privacyAcceptedAt,
            });
            message.success('Registrazione avvenuta con successo! Ora puoi effettuare il login.');
            navigate('/login');
        } catch (error) {
            console.error('Errore nella registrazione:', error);
            message.error('Errore durante la registrazione. Verifica la password amministrativa.');
        }
    };

    const goToLogin = () => {
        navigate('/login');
    };

    return (
        <Layout style={{ minHeight: '100vh', alignItems: 'center', justifyContent: 'center', backgroundColor: 'var(--sfondo)' }}>
            <Button 
                type="link" 
                style={{ position: 'absolute', top: '20px', right: '20px' }}
                onClick={goToLogin}
            >
                Torna al login
            </Button>

            <Content style={{ width: '100%', maxWidth: '400px', padding: '20px', textAlign: 'center' }}>
                <img src={logo} alt="FitLab Logo" className="logo" style={{ width: '200px', marginBottom: '20px' }} />

                <Title level={2} style={{ color: 'var(--primario)' }}>Registrati su FitLab</Title>

                <Form layout="vertical" onFinish={handleSubmit}>
                    <Form.Item label="Nome" required>
                        <Input value={nome} onChange={(e) => setNome(e.target.value)} />
                    </Form.Item>
                    <Form.Item label="Cognome" required>
                        <Input value={cognome} onChange={(e) => setCognome(e.target.value)} />
                    </Form.Item>
                    <Form.Item label="Email" required>
                        <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                    </Form.Item>
                    <Form.Item label="Password" required>
                        <Input.Password value={password} onChange={(e) => setPassword(e.target.value)} />
                    </Form.Item>
                    <Form.Item label="Ruolo" required>
                        <Select value={role} onChange={(value) => setRole(value)} placeholder="Seleziona un ruolo">
                            <Option value="cliente">Cliente</Option>
                            <Option value="trainer">Trainer</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label="Trainer Id">
                        <Input value={trainerId} onChange={(e) => setTrainerId(e.target.value)} placeholder="Inserisci l'id del trainer" />
                    </Form.Item>
                    <Form.Item label="Password Amministratore" required>
                        <Input.Password value={adminPassword} onChange={(e) => setAdminPassword(e.target.value)} placeholder="Inserisci la password amministratore" />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" block style={{ backgroundColor: 'var(--primario)', borderColor: 'var(--primario)' }}>
                            Registrati
                        </Button>
                    </Form.Item>
                </Form>

                {messageText && <Typography.Text type="danger">{messageText}</Typography.Text>}
            </Content>
        </Layout>
    );
};

export default Register;
